import { Button } from "@thilke/ui/components/button";
import { Panel } from "@thilke/ui/components/panel";
import { Separator } from "@thilke/ui/components/separator";
import { FileJson, Package } from "lucide-react";
import { Page as RegistryComponentsPage } from "../../storybook/app/components/page";

type RegistryItem = { name: string; files?: { path: string }[] };
type ComponentsPageProps = {
  origin: string;
  items: RegistryItem[];
  registryName: string;
};
export function ComponentsPage({
  origin,
  items,
  registryName,
}: ComponentsPageProps) {
  return (
    <>
      <section className="grid gap-4 rounded-xl border bg-card p-5 shadow-sm">
        <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
          <div className="max-w-2xl">
            <div className="mb-2 flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-muted-foreground">
              <Package className="size-4" /> registry
            </div>
            <h2 className="text-2xl font-semibold tracking-tight">
              Thilke UI Registry
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              Browse installable Thilke UI components and blocks. Previews
              import <code>@thilke/ui</code> and use the shared token contract.
            </p>
          </div>
          <div className="grid min-w-52 grid-cols-2 gap-2">
            <Panel position="docked" size="sm">
              <div className="text-xs text-muted-foreground">Registry</div>
              <div className="font-mono text-sm">{registryName}</div>
            </Panel>
            <Panel position="docked" size="sm">
              <div className="text-xs text-muted-foreground">Visible</div>
              <div className="font-mono text-sm">{items.length}</div>
            </Panel>
          </div>
        </div>
        <Separator />
        <div className="flex flex-wrap gap-2">
          <Button asChild>
            <a
              href={`${origin}/registry.json`}
              target="_blank"
              rel="noreferrer"
            >
              <FileJson className="size-4" /> registry.json
            </a>
          </Button>
        </div>
      </section>
      <RegistryComponentsPage origin={origin} />
    </>
  );
}
